export default __webpack_public_path__ + "static/media/default.1f94ab4417602bd72e77390f389bc3f3.png";